import React from "react";
import { connect } from "react-redux";
import * as actionCreators from "../../../Store/actions/SearchActions";
import { NavLink } from "react-router-dom";
import classes from "./Breadcrumb.module.css";
import rightBlackarrow from "../../../assets/svg/rightBlackarrow.svg";


const Breadcrumb = (props) => {

    return (
        <div className={classes.Breadcrumb}>
            <div className={`${classes.Navigation} ${classes.OnlybigScreen}`}>
                <small>
                    <NavLink to='/' onClick={() => {
                        props.onChangeVehicleType('all');
                        localStorage.setItem('vehicleType', 'all');
                    }}>home</NavLink>
                    <img src={rightBlackarrow} alt='' />
                </small>
                <small>{props.vehicleType}<img src={rightBlackarrow} alt='' /></small>
                <p className={classes.OnlyLapScreen}>search</p>
            </div>
            <div className={`${classes.SearchResult} ${classes.OnlybigScreen}`}>
                search result : the input coming from serach field
            </div>
            <div className={classes.OnlysmallScreen}
                onClick={() => [
                    props.OpenDrawer()
                ]}>
                <div className={classes.Toggler}></div>
                <div className={classes.Toggler}></div>
                <div className={classes.Toggler}></div>
            </div>
            <div className={classes.ViewControls}>
                <input className={classes.OnlybigScreen}
                    type='radio'
                    name='view'
                    value='list'
                    defaultChecked={props.viewType === 'list' ? true : false}
                    onChange={() => {
                        props.onChangeView('list')
                    }} />
                <input className={classes.OnlybigScreen}
                    type='radio'
                    name='view'
                    value='grid'
                    defaultChecked={props.viewType === 'grid' ? true : false}
                    onChange={() => {
                        props.onChangeView('grid')
                    }} />
                <select onChange={event => {
                    props.sortBy(event.target.value)
                }}>
                    <option value=''>Sort by</option>
                    <option value='Latest'>Latest</option>
                    <option value='Oldest'>Oldest</option>
                    <option value='PriceA'>Price ascending</option>
                    <option value='PriceD'>Price descending</option>
                </select>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        viewType: state.SearchP.viewType,
        vehicleType: state.SearchP.vehicleType
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeView: (type) => { dispatch(actionCreators.changeViewType(type)) },
        onChangeVehicleType: (type) => { dispatch(actionCreators.changeVehicleType(type)) },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Breadcrumb);